import { ClubSubscriptionEnum, ClubSubscriptionType } from '@hefe/models';

export interface TeamSetting {
  key: string;
  children?: TeamSetting[];
  subscription: ClubSubscriptionEnum;
}

export const SETTINGS: TeamSetting[] = [
  {
    key: 'allowViewReplies',
    subscription: ClubSubscriptionType.FIRST,
  },
  {
    key: 'requireReplyReason',
    subscription: ClubSubscriptionType.SECOND,
  },
  {
    key: 'defaultYesReply',
    subscription: ClubSubscriptionType.SECOND,
    children: [
      {
        key: 'games',
        subscription: ClubSubscriptionType.SECOND,
      },
      {
        key: 'practices',
        subscription: ClubSubscriptionType.SECOND,
      },
    ],
  },
];
